module.exports = __webpack_public_path__ + "static/media/facebook.109d812e.svg";